"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookiesStorage = exports.CookiesStorageClass = void 0;
const cookie_manager_1 = require("./cookie_manager");
class CookiesStorageClass {
    constructor() {
        //private cookies: CookieManager;
        this._cookiePrefix = "";
    }
    isSupported() {
        return true;
        // const cookies = JsCookie.getInstance();
        // let result = false;
        // try {
        //     const key = "isSupportedCookieKey";
        //     const value = "isSupportedCookieValue";
        //     cookies.set(key, value, null);
        //     if (cookies.get(key) === value) {
        //         cookies.remove(key, null);
        //         result = true;
        //     }
        // } catch (ex) {
        //     result = false
        // } finally {
        //     return result;
        // }
    }
    setPrefix(val) {
        this._cookiePrefix = val;
    }
    get(key, options = {}) {
        return cookie_manager_1.CookieManager.getCookie(this._cookiePrefix + key);
    }
    getParsed(key) {
        throw new Error("Method not implemented.");
    }
    set(key, value, options = {}) {
        if (options && options.daysOfLife) {
            let expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + options.daysOfLife);
            options.expires = expireDate;
        }
        this.setDomain(options);
        return cookie_manager_1.CookieManager.setCookie(this._cookiePrefix + key, value, options);
    }
    delete(key, options = {}) {
        this.setDomain(options);
        cookie_manager_1.CookieManager.deleteCookie(this._cookiePrefix + key, options);
        return true;
    }
    deleteAllByName(key) {
        cookie_manager_1.CookieManager.deleteAllCookiesByName(this._cookiePrefix + key);
        return true;
    }
    clear() {
        return false;
    }
    setDomain(options) {
        if (options.useRootDomain) {
            options.domain = this.getRootDomain();
        }
        else {
            options.domain = window.location.hostname;
        }
    }
    getRootDomain() {
        let rootDomain = "";
        let hostSegments = window.location.hostname.split(".");
        let domainSegmentsCount = 2;
        // if localhost
        if (hostSegments.length < domainSegmentsCount) {
            return window.location.hostname;
        }
        if (this.cachedRootDomain) {
            return this.cachedRootDomain;
        }
        do {
            rootDomain = "." + hostSegments.slice(-domainSegmentsCount).join(".");
        } while (!this.checkWriteDomainCookie(rootDomain) && domainSegmentsCount++ < hostSegments.length);
        this.cachedRootDomain = rootDomain;
        return rootDomain;
    }
    checkWriteDomainCookie(domain) {
        let cookieKey = "mng_ck_dmn_wrt";
        let result = false;
        const options = {
            domain: domain
        };
        const value = "Done!";
        cookie_manager_1.CookieManager.setCookie(cookieKey, value, options);
        result = cookie_manager_1.CookieManager.getCookie(cookieKey) === value;
        cookie_manager_1.CookieManager.deleteCookie(cookieKey, { domain: domain });
        return result;
    }
    getAllKeys() {
        const keys = cookie_manager_1.CookieManager.getAllKeys();
        return keys;
    }
    getAllItems() {
        const items = [];
        try {
            const keys = [...this.getAllKeys()];
            for (let key of keys) {
                items.push({ key: key, val: this.get(key) });
            }
            return items;
        }
        catch (ex) {
            return items;
        }
    }
}
exports.CookiesStorageClass = CookiesStorageClass;
exports.CookiesStorage = new CookiesStorageClass();
